/**
 * Component Registry for FLATZ 480
 * 
 * Inherits from @vibesites-z-modular/theme-avenue and allows property-specific overrides.
 */

import type { ComponentRegistry } from '@vibesites/runtime';
import { registry as parentRegistry } from '@vibesites-z-modular/theme-avenue/registry';
import { SocialFollow } from './components/SocialFollow';
import { PropertyOverview } from './components/PropertyOverview';
import { CTASection } from './components/CTASection';
import { AmenitiesList } from './components/AmenitiesList';
import { LifestyleCommunity } from './components/LifestyleCommunity';
import { Footer } from './components/Footer';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { ReviewsCallout } from './components/ReviewsCallout';
import { FloorplansList } from './components/FloorplansList';
import { InteractiveMapSection } from './components/InteractiveMapSection';
import { ApplyNow } from './components/ApplyNow';
import { BetterBuiltBenefits } from './components/BetterBuiltBenefits';
import { BetterBuiltIntro } from './components/BetterBuiltIntro';
import { BetterBuiltSteelVsWood } from './components/BetterBuiltSteelVsWood';
import { ContactForm } from './components/ContactForm';
import { FlexibleLivingPrograms } from './components/FlexibleLivingPrograms';
import { Gallery } from './components/Gallery';
import { LifestyleCTA } from './components/LifestyleCTA';
import { NeighborhoodMap } from './components/NeighborhoodMap';
import { PetPolicy } from './components/PetPolicy';
import { ResidentAccess } from './components/ResidentAccess';
import { RewardsPrograms } from './components/RewardsPrograms';
import { ScheduleTourForm } from './components/ScheduleTourForm';
import { TeamCTA } from './components/TeamCTA';
import { TeamMembers } from './components/TeamMembers';
import { ThankYouContent } from './components/ThankYouContent';

/**
 * Property-specific component overrides.
 * Uncomment and customize components as needed.
 */
const propertyOverrides: Partial<ComponentRegistry> = {
  Header,
  Footer,
  Hero,
  ReviewsCallout,
  SocialFollow,
  PropertyOverview,
  CTASection,
  AmenitiesList,
  LifestyleCommunity,
  FloorplansList,
  InteractiveMapSection,
  ApplyNow,
  BetterBuiltBenefits,
  BetterBuiltIntro,
  BetterBuiltSteelVsWood,
  ContactForm,
  FlexibleLivingPrograms,
  Gallery,
  LifestyleCTA,
  NeighborhoodMap,
  PetPolicy,
  ResidentAccess,
  RewardsPrograms,
  ScheduleTourForm,
  TeamCTA,
  TeamMembers,
  ThankYouContent,
};

/**
 * Final merged registry for this property.
 * Inherits all components from the parent theme, with property overrides.
 */
export const registry: ComponentRegistry = {
  ...parentRegistry,
  ...propertyOverrides,
};

export default registry;
